module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-01-82004cb18d4a708a8b5092f7e4df9d9b.png";